import React, { useCallback, useMemo, useState } from "react";
import { Box, CircularProgress, Link } from "@material-ui/core";

import { BillFileInfo } from "../../../api/services";
import { useGlobalError } from "../../ErrorModal";
import { getBackendUrl, client } from "../../../api/client";
import { ErrorLevel } from "../../ErrorModal/ErrorProvider";

export const FileAction: React.FC<{
  file: BillFileInfo | null;
}> = ({ file }) => {
  const { status, url, fileType } = file || {};
  const { setError } = useGlobalError();
  const [checking, setChecking] = useState(false);

  const { href, displayName } = useMemo(() => {
    return {
      href: url ? new URL(url, getBackendUrl()).href : null,
      displayName: fileType?.toUpperCase(),
    };
  }, [fileType, url]);

  const handleClick = useCallback(
    (e: any) => {
      e.preventDefault();
      if (file == null || checking) {
        return;
      }
      const loadError = {
        title: `Error loading ${displayName}`,
        message: `We can't load the ${displayName} of this bill.`,
        handlerText: "Ok",
        level: ErrorLevel.Error,
      };
      if (status === "Ready" && href) {
        setChecking(true);
        client
          .head(href)
          .then(() => window.open(href, "_blank"))
          .catch(() => setError(loadError))
          .then(() => setChecking(false));
        return;
      }
      setError(
        status === "GdprRemoval"
          ? {
              title: `${displayName} deleted`,
              message: `The ${displayName} of this bill has been deleted in accordance with GDPR requirements.`,
              handlerText: "Ok",
              level: ErrorLevel.Info,
            }
          : loadError,
      );
    },
    [checking, displayName, file, href, setError, status],
  );
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      minWidth="56px"
      data-testid="FileAction"
    >
      {file != null ? (
        <>
          <Link
            href="#"
            underline="none"
            color={checking ? "textSecondary" : "primary"}
            onClick={handleClick}
            variant="body2"
          >
            {displayName}
          </Link>
          {checking ? (
            <Box clone display="inline-block" ml={0.5}>
              <CircularProgress
                size={18}
                color="secondary"
                data-testid="Loader"
              />
            </Box>
          ) : null}
        </>
      ) : null}
    </Box>
  );
};
